"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipInnerWrapper = exports.TooltipMain = exports.TooltipHover = exports.Tooltip = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../../styles/theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TooltipHover = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1mifdt20",
  label: "TooltipHover"
})("display:inline;font-family:", _theme.fonts.sansSerif, ";position:relative;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.TooltipHover = TooltipHover;
var TooltipMain = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1mifdt21",
  label: "TooltipMain"
})("visibility:", function (props) {
  return props.hoverOn ? 'visible' : 'hidden';
}, ";font-size:12px;font-weight:400;text-align:center;left:auto;right:50%;position:absolute;z-index:250;top:auto;bottom:28px;margin-right:-80px;min-width:160px;max-width:320px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3VpX2VsZW1lbnRzL3Rvb2x0aXAvVG9vbHRpcC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV2lDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3VpX2VsZW1lbnRzL3Rvb2x0aXAvVG9vbHRpcC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNvbG9ycywgZm9udHMgfSBmcm9tICcuLi8uLi9zdHlsZXMvdGhlbWUnO1xuXG5jb25zdCBUb29sdGlwSG92ZXIgPSBzdHlsZWQoJ2RpdicpYFxuICBkaXNwbGF5OiBpbmxpbmU7XG4gIGZvbnQtZmFtaWx5OiAke2ZvbnRzLnNhbnNTZXJpZn07XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbmA7XG5cbmNvbnN0IFRvb2x0aXBNYWluID0gc3R5bGVkKCdkaXYnKWBcbiAgdmlzaWJpbGl0eTogJHtwcm9wcyA9PiAocHJvcHMuaG92ZXJPbiA/ICd2aXNpYmxlJyA6ICdoaWRkZW4nKX07XG4gIGZvbnQtc2l6ZTogMTJweDtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBsZWZ0OiBhdXRvO1xuICByaWdodDogNTAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHotaW5kZXg6IDI1MDtcbiAgdG9wOiBhdXRvO1xuICBib3R0b206IDI4cHg7XG4gIG1hcmdpbi1yaWdodDogLTgwcHg7XG4gIG1pbi13aWR0aDogMTYwcHg7XG4gIG1heC13aWR0aDogMzIwcHg7XG5gO1xuXG5jb25zdCBUb29sdGlwSW5uZXJXcmFwcGVyID0gc3R5bGVkKCdkaXYnKWBcbiAgYm94LXNoYWRvdzogMCAycHggM3B4IDAgJHtjb2xvcnMuZ3JleS5zZWNvbmRhcnlEYXJrfTtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBiYWNrZ3JvdW5kOiAke2NvbG9ycy53aGl0ZX07XG4gIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgcGFkZGluZzogOHB4IDExcHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkICR7Y29sb3JzLmJsdWUuc2Vjb25kYXJ5RGFya307XG4gIGZsb2F0OiBub25lO1xuYDtcblxuY2xhc3MgVG9vbHRpcCBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIGNvbnN0cnVjdG9yKHByb3BzKSB7XG4gICAgc3VwZXIocHJvcHMpO1xuICAgIHRoaXMuc3RhdGUgPSB7IGhvdmVyT246IGZhbHNlIH07XG4gIH1cblxuICB0b2dnbGVIb3Zlck9uID0gKCkgPT4gdGhpcy5zZXRTdGF0ZSh7IGhvdmVyT246IHRydWUgfSk7XG5cbiAgdG9nZ2xlSG92ZXJPZmYgPSAoKSA9PiB0aGlzLnNldFN0YXRlKHsgaG92ZXJPbjogZmFsc2UgfSk7XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4sIGNvbnRlbnQgfSA9IHRoaXMucHJvcHM7XG4gICAgY29uc3QgeyBob3Zlck9uIH0gPSB0aGlzLnN0YXRlO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxUb29sdGlwSG92ZXIgb25Nb3VzZUVudGVyPXt0aGlzLnRvZ2dsZUhvdmVyT259IG9uTW91c2VMZWF2ZT17dGhpcy50b2dnbGVIb3Zlck9mZn0+XG4gICAgICAgIHtjaGlsZHJlbn1cbiAgICAgICAgPFRvb2x0aXBNYWluIGhvdmVyT249e2hvdmVyT259PlxuICAgICAgICAgIDxUb29sdGlwSW5uZXJXcmFwcGVyPntjb250ZW50fTwvVG9vbHRpcElubmVyV3JhcHBlcj5cbiAgICAgICAgPC9Ub29sdGlwTWFpbj5cbiAgICAgIDwvVG9vbHRpcEhvdmVyPlxuICAgICk7XG4gIH1cbn1cblxuVG9vbHRpcC5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMub25lT2ZUeXBlKFtcbiAgICBQcm9wVHlwZXMuYXJyYXlPZihQcm9wVHlwZXMubm9kZSksXG4gICAgUHJvcFR5cGVzLm5vZGUsXG4gICAgUHJvcFR5cGVzLnN0cmluZ1xuICBdKS5pc1JlcXVpcmVkLFxuICBjb250ZW50OiBQcm9wVHlwZXMub25lT2ZUeXBlKFtcbiAgICBQcm9wVHlwZXMuYXJyYXlPZihQcm9wVHlwZXMubm9kZSksXG4gICAgUHJvcFR5cGVzLm5vZGUsXG4gICAgUHJvcFR5cGVzLnN0cmluZ1xuICBdKS5pc1JlcXVpcmVkXG59O1xuXG5leHBvcnQgeyBUb29sdGlwLCBUb29sdGlwSG92ZXIsIFRvb2x0aXBNYWluLCBUb29sdGlwSW5uZXJXcmFwcGVyIH07XG4iXX0= */"));
exports.TooltipMain = TooltipMain;
var TooltipInnerWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1mifdt22",
  label: "TooltipInnerWrapper"
})("box-shadow:0 2px 3px 0 ", _theme.colors.grey.secondaryDark, ";border-radius:4px;background:", _theme.colors.white, ";color:", _theme.colors.black, ";display:inline-block;padding:8px 11px;border:1px solid ", _theme.colors.blue.secondaryDark, ";float:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.TooltipInnerWrapper = TooltipInnerWrapper;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleHoverOn", function () {
      return _this.setState({
        hoverOn: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleHoverOff", function () {
      return _this.setState({
        hoverOn: false
      });
    });

    _this.state = {
      hoverOn: false
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content;
      var hoverOn = this.state.hoverOn;
      return _react.default.createElement(TooltipHover, {
        onMouseEnter: this.toggleHoverOn,
        onMouseLeave: this.toggleHoverOff
      }, children, _react.default.createElement(TooltipMain, {
        hoverOn: hoverOn
      }, _react.default.createElement(TooltipInnerWrapper, null, content)));
    }
  }]);

  return Tooltip;
}(_react.default.Component);

exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  content: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired
};